import { render, staticRenderFns } from "./PersonalArea.vue?vue&type=template&id=71814f86&"
import script from "./PersonalArea.vue?vue&type=script&lang=ts&"
export * from "./PersonalArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports